import { Address } from "@/models/address";
import { Relay, RELAY_POINT_NAME_PREFIX } from "@/models/relay";
import { Shipment } from "@/models/shipment";

export interface RelayDataProvider {
  fetchRelayPoints(address: Address, shipment: Shipment): Promise<Relay[]>;
  getRelayPointById(realyPointId: string): Promise<Relay>;
}

const dummyDataProvider: RelayDataProvider = {
  fetchRelayPoints: () => Promise.resolve([]),
  getRelayPointById: (relayPointId) => Promise.reject(),
}

const RELAY_POINT_NAME_REGEX = new RegExp(RELAY_POINT_NAME_PREFIX + "(.+)")

export default class RelayService {
  #dataProvider: RelayDataProvider = dummyDataProvider;

  static of(): RelayService {
    return new RelayService();
  }

  registerRelayProvider(relayProvider: RelayDataProvider) {
    this.#dataProvider = relayProvider;
  }

  fetchRelayPoints(address: Address, shipment: Shipment) {
    return this.#dataProvider.fetchRelayPoints(address, shipment);
  }

  getRelayPointByName(relayPointName) {
    const relayPointRegexResult = RELAY_POINT_NAME_REGEX.exec(relayPointName)
    if (!relayPointRegexResult) {
      throw new Error("invalid relay point name '" + relayPointName + "'")
    }
    return this.#dataProvider.getRelayPointById(relayPointRegexResult[1])
  }

}